import React from "react";
import Modal from "react-bootstrap/Modal";
import { Tab, Tabs } from "react-bootstrap";
import { getDate } from "utils/formatDate";
import configs from "constants/configs";
import { formatNumber } from "utils/currencyFormat";
import choVayConst, { LaiSuatText2 } from "constants/choVayConst";
import LanThanhToanTable from "../LanThanhToanTable";
import LichSuVayThemTraBotGocView from "../LichSuVayThemTraBotGocView";
import ListTaiSanCamCoView from "../ListTaiSanCamCoView";
import LichSuGiaHanView from "../LichSuGiaHanView";
import LichSuNoPhaiThuView from "../LichSuNoPhaiThuView";
import ListGhiChuView from "../ListGhiChuView";
import LichSuHopDongView from "../LichSuHopDongView";
import CamDoApi from "service/chiTietHopDongApi";
import CauHinhApi from "service/cauHinhApi";
import cauHinh from "utils/cauHinh";
import handleEscapeKey from "utils/handleEscapeKey";
import {
  LAI_TRA_GOP_TRIEU_NGAY,
  laiDonViRaLaiTrieuNgay,
} from "utils/laiTraGop";
let currentSlider = null;
const runSlider = () => {
  setTimeout(() => {
    // // Init fancyBox
    window.jQuery().fancybox({
      selector: ".slick-slide:not(.slick-cloned)",
      hash: false,
    });
    if (currentSlider) currentSlider.slick("unslick");
    currentSlider = window.jQuery(".main-slider").slick({
      slidesToShow: 7,
      slidesToScroll: 7,
      infinite: true,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
          },
        },
      ],
    });
    window.jQuery(".main-slider").resize();
  }, 1);
};
class ChiTietHopDong extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: props.show || false, // Trạng thái popup
      dataSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 5,
      },
      dataGiaHanSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 5,
      },
      dataVTTBSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 5,
      },
      dataCamCoSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 5,
      },
      dataNoPhaiThuSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 5,
      },
      dataGhiChuSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 5,
      },
      dataLichSuSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 5,
      },
      choVay: {},
      cacLoaiPhiKhac: [],
      cacLoaiPhiHangKy: [],
      isCauHinhT77: false,
      isMoney88: false,
      laiTraGop: 0,
      anDinhNgayThangTraGop: false,
      thuocTinhThongKe: null,
    };
    this.toggleModal = this.props.onHide.bind(this);
    // Tạo instance của useEscapeKey và gán vào this.escListener
    this.escListener = handleEscapeKey(this.props.onHide);
  }
  componentDidMount() {
    if (this.state.isModalOpen) this.escListener.addListener();
    let {
      show,
      data,
      dbName,
      getLichSuGiaHanChoVay,
      getLanDongLaiChoVay,
      getLichSuVayThemTraBotGoc,
      getListTaiSanCamCo,
      getLichSuNoPhaiThu,
      getListGhiChu,
      getLichSuHopDong,
    } = this.props;
    let {
      dataSearch,
      dataGiaHanSearch,
      dataVTTBSearch,
      dataCamCoSearch,
      dataNoPhaiThuSearch,
      dataGhiChuSearch,
      dataLichSuSearch,
    } = this.state;
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200 && response.data.length > 0) {
        const configCauHinhT77 = response.data.find(
          (e) =>
            e.keyConfig &&
            e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsCauHinhT77.toUpperCase(),
        );
        const configMoney88 = response.data.find(
          (e) =>
            e.keyConfig &&
            e.keyConfig.toUpperCase() === cauHinh.sKey.IsMoney88.toUpperCase(),
        );
        const isMoney88 =
          configMoney88 != null && configMoney88.valueConfig === "1";
        const configLaiTraGop = response.data.find(
          (e) => e.keyConfig && e.keyConfig.toUpperCase() === "_LAITRAGOP",
        );
        const configAnDinhNgayThangTraGop = response.data.find(
          (e) =>
            e.keyConfig &&
            e.keyConfig.toUpperCase() === "_ANDINHNGAYTHANGTRAGOP",
        );
        this.setState({
          isCauHinhT77:
            configCauHinhT77 != null && configCauHinhT77.valueConfig === "1",
          isMoney88,
          laiTraGop: configLaiTraGop
            ? parseInt(configLaiTraGop.valueConfig, 10) || 0
            : 0,
          anDinhNgayThangTraGop:
            configAnDinhNgayThangTraGop != null &&
            String(configAnDinhNgayThangTraGop.valueConfig).toLowerCase() ===
              "true",
        });
        if (isMoney88) {
          this.getThuocTinhThongKeHopDong();
        }
      }
    });
    if (show) {
      CamDoApi.chiTietCacLoaiPhiHopDong(data.ChoVayId, data.Type, dbName).then(
        (response) => {
          if (response.status === 200) {
            this.setState({ cacLoaiPhiKhac: response.data });
          }
          console.log(response, "loiaij hhis chi tiết hợp đồng");
        },
      );
      CamDoApi.chiTietCacLoaiPhiHopDong1(data.ChoVayId, data.Type, dbName).then(
        (response) => {
          console.log(response, "2loiaij hhis chi tiết hợp đồng");
          if (response.status === 200) {
            this.setState({ cacLoaiPhiHangKy: response.data });
          }
        },
      );
      dataGiaHanSearch.choVayId = data.ChoVayId;
      dataSearch.choVayId = data.ChoVayId;
      dataVTTBSearch.choVayId = data.ChoVayId;
      dataCamCoSearch.choVayId = data.ChoVayId;
      dataNoPhaiThuSearch.choVayId = data.ChoVayId;
      dataGhiChuSearch.choVayId = data.ChoVayId;
      dataLichSuSearch.choVayId = data.ChoVayId;
      dataGiaHanSearch.dbName = dbName;
      dataSearch.dbName = dbName;
      dataVTTBSearch.dbName = dbName;
      dataCamCoSearch.dbName = dbName;
      dataNoPhaiThuSearch.dbName = dbName;
      dataGhiChuSearch.dbName = dbName;
      dataLichSuSearch.dbName = dbName;
      this.setState({
        choVay: data,
        dataSearch,
        dataGiaHanSearch,
        dataVTTBSearch,
        dataCamCoSearch,
        dataGhiChuSearch,
        dataLichSuSearch,
      });
      getLichSuVayThemTraBotGoc(dataVTTBSearch);
      getLichSuGiaHanChoVay(dataGiaHanSearch);
      getLanDongLaiChoVay(dataSearch);
      getListTaiSanCamCo(dataCamCoSearch);
      getLichSuNoPhaiThu(dataNoPhaiThuSearch);
      getListGhiChu(dataGhiChuSearch);
      getLichSuHopDong(dataLichSuSearch);
    }
  }

  componentWillUnmount() {
    // Gỡ listener khi component unmount
    this.escListener.removeListener();
  }

  //Nguồn khách hàng / nghề nghiệp / khu vực / hình thức vay của hợp đồng - chỉ dùng khi bật cấu hình isMoney88
  getThuocTinhThongKeHopDong = () => {
    let { data, dbName } = this.props;
    if (!data || !data.ChoVayId) return;
    CamDoApi.thuocTinhThongKeHopDong(data.ChoVayId, dbName).then(
      (response) => {
        if (response.ok && response.data) {
          this.setState({ thuocTinhThongKe: response.data });
        }
      },
    );
  };

  toggleModal() {
    // Cập nhật trạng thái popup và thêm/xóa listener khi cần
    this.setState(
      (prevState) => ({ isModalOpen: !prevState.isModalOpen }),
      () => {
        if (this.state.isModalOpen) {
          this.escListener.addListener();
        } else {
          this.escListener.removeListener();
        }
      },
    );
  }

  handlePageChange = () => (pageNumber) => {
    let { getLanDongLaiChoVay } = this.props;
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    getLanDongLaiChoVay(dataSearch);
  };
  handlePageChangeGiaHan = () => (pageNumber) => {
    let { getLichSuGiaHanChoVay } = this.props;
    let { dataNoPhaiThuSearch } = this.state;
    dataNoPhaiThuSearch.pageIndex = pageNumber;
    this.setState({ dataNoPhaiThuSearch });
    getLichSuGiaHanChoVay(dataNoPhaiThuSearch);
  };
  handlePageChangeLichSu = () => (pageNumber) => {
    let { getLichSuHopDong } = this.props;
    let { dataLichSuSearch } = this.state;
    dataLichSuSearch.pageIndex = pageNumber;
    this.setState({ dataLichSuSearch });
    getLichSuHopDong(dataLichSuSearch);
  };
  handlePageChangeGhiChu = () => (pageNumber) => {
    let { getListGhiChu } = this.props;
    let { dataGhiChuSearch } = this.state;
    dataGhiChuSearch.pageIndex = pageNumber;
    this.setState({ dataGhiChuSearch });
    getListGhiChu(dataGhiChuSearch);
  };
  handlePageChangeLSNoPhaiThu = () => (pageNumber) => {
    let { getLichSuNoPhaiThu } = this.props;
    let { dataNoPhaiThuSearch } = this.state;
    dataNoPhaiThuSearch.pageIndex = pageNumber;
    this.setState({ dataNoPhaiThuSearch });
    getLichSuNoPhaiThu(dataNoPhaiThuSearch);
  };

  returnImageLink(strImage) {
    let imageTS = strImage;
    if (typeof strImage === "undefined" || strImage === "") {
      imageTS = "Image/no_image.png";
    }
    if (imageTS && imageTS.indexOf("http") > -1) {
    } else {
      imageTS = configs.apiViewUpload + imageTS;
    }
    return imageTS;
  }
  onHide = () => {
    this.setState({ isModalOpen: false });
    this.props.onHide();
  };
  render() {
    let {
      show,
      data,
      onHide,
      quanlychovay,
      chitiethopdong,
      cauhinh,
      setModalTaiSan,
    } = this.props;
    let { objListDonglai, LichSuGiaHan } = quanlychovay;
    let {
      List,
      TongCanThanhToan,
      TongPhiKhac,
      TongPhiKho,
      TongThanhToan,
      TongTienGoc,
      TongTienLai,
      totalRow,
      TongPhiKhacHangKy,
      TongPhiDongLaiCham,
    } = objListDonglai;
    let { ListGiaHan, TotalRowGiaHan } = LichSuGiaHan;

    let {
      objLichSuVTTB,
      objListCamCo,
      objLichSuNoPhaiThu,
      objListGhiChu,
      objLichSuHopDong,
    } = chitiethopdong;
    let { TotalRows, TongTienVayThemTraBotGoc } = objLichSuVTTB;
    let ListVTTB = objLichSuVTTB.List;
    let ListCamCo = objListCamCo.List;
    let TotalRowsCamCo = objListCamCo.TotalRows;
    let CamDoTongPhiKho = objListCamCo.CamDoTongPhiKho;

    let ListLSNoPhaiThu = objLichSuNoPhaiThu.List;
    let TotalRowNoPhaiThu = objLichSuNoPhaiThu.TotalRows;
    let { TotalValue } = objLichSuNoPhaiThu;

    let ListGhiChu = objListGhiChu.List;
    let TotalRowsGhiChu = objListGhiChu.TotalRows;
    // TotalRows: 0,
    //     List: [],
    //     TotalSoTien: 0,
    let ListLichSu = objLichSuHopDong.List;
    let TotalRowLichSu = objLichSuHopDong.TotalRows;
    let TotalSoTienLS = objLichSuHopDong.TotalSoTien;

    let {
      dataSearch,
      dataGiaHanSearch,
      dataNoPhaiThuSearch,
      dataGhiChuSearch,
      dataLichSuSearch,
      isCauHinhT77,
      isMoney88,
      laiTraGop,
      anDinhNgayThangTraGop,
      thuocTinhThongKe,
    } = this.state;
    let {
      Code,
      CustomerName,
      PhiDongLaiCham,
      nameCus,
      Birthday,
      CustomerAddress,
      Img,
      phoneCus,
      SoTienVayConLai,
      NgayVay,
      NgayTra,
      KieuLaiSuat,
      BeforeAfter,
      SoLanTra,
      CountTypePaid,
      CreatedTime,
      CreatedUser,
      Type,
      Note,
      TypePaid,
      Sotienvay,
      BocTrongVong,
      StatusPaidHo,
      ValueLai,
      ChiPhiVay,
      LinkDinhKem,
      IsDuNoGiamDan,
      LoaiTinhLai,
      Phantram,
      LaiNgay,
    } = data;

    let listFile = [];
    if (typeof LinkDinhKem != "undefined" && LinkDinhKem != null) {
      let arrFile = LinkDinhKem.split(";");
      listFile = arrFile.map((item, index) => {
        const link = {
          Name: item.substr(item.lastIndexOf("/") + 1),
          url: item,
        };
        if (link.url.lastIndexOf("http") == -1) {
          link.view = configs.apiViewUpload + link.url;
        } else {
          link.view = link.url;
        }
        return link;
      });
    }
    let { PhiKho } = cauhinh.objConfig;
    if (!SoTienVayConLai) SoTienVayConLai = Sotienvay;
    let image = Img;
    if (typeof Img === "undefined" || Img === "") {
      image = "/app-assets/images/icon-avatar-default.png";
    } else {
      if (image && image.indexOf("http") > -1) {
      } else {
        image = configs.apiViewUpload + image;
      }
    }
    let lstAnh = [];
    let NoteTaiSan = "";
    if (ListCamCo.length > 0) {
      lstAnh = ListCamCo[0].Img ? ListCamCo[0].Img.split(",") : [];
      lstAnh = lstAnh.map(function (elem) {
        if (elem.indexOf("Morman") > -1) {
          return configs.apiViewUpload + elem;
        }
        if (elem.indexOf("http") == -1) {
          return configs.imageServer + elem;
        } else {
          return elem;
        }
      });
      NoteTaiSan = ListCamCo[0].Note;
    }
    // if (Type !== 3) runSlider();
    console.log(this.state.cacLoaiPhiHangKy, "!");
    console.log(this.state.cacLoaiPhiKhac, "!2");
    return (
      <Modal
        onHide={this.onHide}
        show={show}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              {/* <i className="mdi mdi-file-document"></i> */}
              <img src="/app-assets/images/icon-chi-tiet-lich-su.png" />
            </span>
            <span style={{ marginLeft: "-20px", marginTop: "10px" }}>
              Chi tiết hợp đồng:{" "}
            </span>{" "}
            <span className="color-xanh-bold">{Code}</span>
          </h4>
          <button type="button" className="close-popup-new" onClick={onHide}>
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <div className="form-thongtin-kh-new" style={{ padding: "10px" }}>
            <div id="accordionWrap6" role="tablist" aria-multiselectable="true">
              <div className="card collapse-icon accordion-icon-rotate">
                <div id="heading61" className="card-header ">
                  <a
                    data-toggle="collapse"
                    data-parent="#accordionWrap6"
                    href="#accordion61"
                    aria-expanded="true"
                    aria-controls="accordion61"
                    className="card-title lead"
                  >
                    <img src="/app-assets/images/icon-thong-tin-khach-vay-v2.png" />{" "}
                    <span className="color-xanh-bold">
                      {" "}
                      Thông tin khách vay
                    </span>
                  </a>
                </div>
                <div
                  id="accordion61"
                  aria-labelledby="heading61"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="thongtin-kh-new thong-tin-khach-hang">
                        <div className="row col-md-12">
                          <div className="col-md-2 no-image">
                            <div
                              className="col-md-2 no-image main-slider"
                              id="main-slider1"
                            >
                              <a
                                href={
                                  image && image.indexOf("http") > -1
                                    ? image
                                    : image.indexOf("/Upload/TaiSanImage/") > -1
                                      ? configs.imageServer + image
                                      : configs.apiViewUpload + image
                                }
                                data-fancybox="images"
                              >
                                <img
                                  alt=""
                                  id="ctl00_ContentPlaceHolder1_customerImage"
                                  disabled="disabled"
                                  className="img-responsive img-thong-tin-khach-vay "
                                  src={
                                    image && image.indexOf("http") > -1
                                      ? image
                                      : image.indexOf("/Upload/TaiSanImage/") >
                                          -1
                                        ? configs.imageServer + image
                                        : configs.apiViewUpload + image
                                  }
                                />
                              </a>
                            </div>
                          </div>

                          <div className="col-md-8">
                            <ul className="list-detailHD">
                              <li>
                                {" "}
                                <span className="color-xanh-bold">
                                  {CustomerName}
                                </span>{" "}
                              </li>
                              <li>
                                {" "}
                                <img src="/app-assets/images/icon-birthday-v2.png" />
                                <span className="color7">
                                  &nbsp;
                                  {getDate(Birthday)
                                    ? getDate(Birthday)
                                    : "Không có thông tin"}
                                </span>{" "}
                              </li>
                              <li>
                                {" "}
                                <img src="/app-assets/images/icon-so-dien-thoai-v2.png" />
                                <span className="color7">
                                  &nbsp;
                                  {phoneCus ? phoneCus : "Không có thông tin"}
                                </span>
                              </li>
                              <li>
                                {" "}
                                <img src="/app-assets/images/icon-dia-chi-v2.png" />{" "}
                                <span className="color7">
                                  &nbsp;
                                  {CustomerAddress
                                    ? CustomerAddress
                                    : "Không có thông tin"}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="tab-detail-hd" style={{ padding: "10px" }}>
            <Tabs className="tab-detail-mm">
              <Tab
                eventKey="thongtinvay"
                title={<h4 className="nav-link tab-v2">Thông tin vay</h4>}
              >
                <div className="select-thongtinvay">
                  <div className="row">
                    <div className="col-md-4 col-lg-4">
                      <div
                        className="from-thongtinvay"
                        style={{ borderLeft: "none" }}
                      >
                        <div className="row">
                          <div className="col-6">
                            <p>Số tiền vay:</p>
                          </div>
                          <div className="col-6 text-left text-normal">
                            <p>
                              <span className="color-do">
                                {formatNumber(SoTienVayConLai)}
                              </span>{" "}
                              (vnđ)
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <p>Ngày vay:</p>
                          </div>
                          <div className="col-6 text-left text-normal">
                            <p>{getDate(NgayVay)}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <p>Kiểu vay:</p>
                          </div>
                          <div className="col-6 text-left text-normal">
                            <p>
                              {choVayConst.TypeText[Type]}{" "}
                              {Type === 2 &&
                                (StatusPaidHo === 1
                                  ? "- Trả lãi thiếu"
                                  : "- Trả lãi đủ")}
                              {LoaiTinhLai === 2 && "- Trả gốc lãi"}
                              {LoaiTinhLai === 3 && "- Dư nợ giảm dần"}
                            </p>
                          </div>
                        </div>
                        {typeof this.state.cacLoaiPhiKhac != "undefined" &&
                        this.state.cacLoaiPhiKhac.length !== 0 ? (
                          this.state.cacLoaiPhiKhac.length > 0 &&
                          this.state.cacLoaiPhiKhac.map((item, index) => {
                            console.log(item, "1111111ffffff");
                            return (
                              <>
                                {item.Active === true && item.GiaTri > "0" && (
                                  <>
                                    <div key={index} className="row">
                                      <div className="col-6">
                                        <p>{item.TenPhiKhacHangKy}:</p>
                                      </div>
                                      <div className="col-6 text-left text-normal">
                                        <p>
                                          {formatNumber(item.GiaTri)}{" "}
                                          {item.LoaiPhiKhacHangKyChon === 1
                                            ? "(VNĐ)"
                                            : "%"}
                                        </p>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </>
                            );
                          })
                        ) : (
                          <p></p>
                        )}
                        {typeof this.state.cacLoaiPhiHangKy != "undefined" &&
                        this.state.cacLoaiPhiHangKy.length !== 0 ? (
                          this.state.cacLoaiPhiHangKy.length > 0 &&
                          this.state.cacLoaiPhiHangKy.map((item, index) => {
                            console.log(item, "1111111ffffff");
                            return (
                              <>
                                <div key={index} className="row">
                                  <div className="col-6">
                                    <p>{item.TenPhiKhac}:</p>
                                  </div>
                                  <div className="col-6 text-left text-normal ">
                                    <p>
                                      {formatNumber(item.GiaTri)}{" "}
                                      {item.LoaiPhiKhacChon === 1
                                        ? "(vnđ)"
                                        : "%"}
                                    </p>
                                  </div>
                                </div>
                              </>
                            );
                          })
                        ) : (
                          <p></p>
                        )}
                        <div className="row">
                          <div className="col-6">
                            <p>Thời gian tạo:</p>
                          </div>
                          <div className="col-6 text-left text-normal">
                            <p>{CreatedTime}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <p>Người tạo hợp đồng:</p>
                          </div>
                          <div className="col-6 text-left text-normal">
                            <p className="word-break">{CreatedUser}</p>
                          </div>
                        </div>
                        {isMoney88 &&
                          [
                            ["Nguồn khách hàng", "TenNguonKh"],
                            ["Nghề nghiệp", "TenNgheNghiep"],
                            ["Khu vực", "TenKhuVuc"],
                            ["Hình thức vay", "TenHinhThucVay"],
                          ].map(([nhan, truong]) => (
                            <div className="row" key={truong}>
                              <div className="col-6">
                                <p>{nhan}:</p>
                              </div>
                              <div className="col-6 text-left text-normal">
                                <p className="word-break">
                                  {thuocTinhThongKe && thuocTinhThongKe[truong]
                                    ? thuocTinhThongKe[truong]
                                    : "Không có thông tin"}
                                </p>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="col-md-5 col-lg-5">
                      <div className="from-thongtinvay">
                        <div className="row">
                          <div className="col-6">
                            <p>Ngày bắt đầu trả lãi:</p>
                          </div>
                          <div className="col-6 text-left text-normal">
                            <p>{getDate(NgayVay)}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <p>Kiểu đóng lãi:</p>
                          </div>
                          <div className="col-6 text-left text-normal">
                            <p>{choVayConst.BeforeAfterText[BeforeAfter]}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <p>Kỳ đóng lãi:</p>
                          </div>
                          <div className="col-6 text-left text-normal">
                            <p>
                              {CountTypePaid}{" "}
                              {TypePaid === 1
                                ? "ngày"
                                : TypePaid === 4
                                  ? "tuần"
                                  : "tháng"}{" "}
                              {Type === 2 ? "góp" : "đóng"} một lần | trả theo{" "}
                              {TypePaid === 1
                                ? "ngày"
                                : TypePaid === 4
                                  ? "tuần"
                                  : "tháng"}
                            </p>
                          </div>
                        </div>
                        {Type !== 2 && !IsDuNoGiamDan && (
                          <div className="row">
                            <div className="col-6">
                              <p>Lãi suất:</p>
                            </div>
                            <div className="col-6 text-left text-normal">
                              <p className="home-new-yellow">
                                {choVayConst.KieuLaiSuatText[KieuLaiSuat]}:{" "}
                                <span className="color-cam">
                                  {LaiSuatText2(data, KieuLaiSuat)}
                                </span>
                              </p>
                            </div>
                          </div>
                        )}
                        {Type == 1 && (
                          <div className="row">
                            <div className="col-6">
                              <p> Phí phạt:</p>
                            </div>
                            <div className="col-6 text-left text-normal">
                              <p className="home-new-yellow">
                                <span className="color-cam">
                                  {PhiDongLaiCham} %
                                </span>
                              </p>
                            </div>
                          </div>
                        )}
                        {/* {Type == 1 && (
                          <div className="row">
                            <div className="col-6">
                              <p> Lãi suất:</p>
                            </div>
                            <div className="col-6 text-left text-normal">
                              <p className="home-new-yellow">
                                {choVayConst.KieuLaiSuatText[KieuLaiSuat]}:{" "}
                                <span className="color-cam">
                                  {KieuLaiSuat === 1 &&
                                    LaiNgay + "đ / tr/ ngày"}
                                  {KieuLaiSuat === 3 &&
                                    Phantram.toFixed(2) + "%"}
                                </span>
                              </p>
                            </div>
                          </div>
                        )} */}
                        {Type == 1 &&
                          (LoaiTinhLai == 2 || LoaiTinhLai == 3) && (
                            <div className="row">
                              <div className="col-6">
                                <p> Lãi suất:</p>
                              </div>
                              <div className="col-6 text-left text-normal">
                                <p className="home-new-yellow">
                                  {choVayConst.KieuLaiSuatText[KieuLaiSuat]}:{" "}
                                  <span className="color-cam">
                                    {KieuLaiSuat === 1 &&
                                      LaiNgay + "đ / tr/ ngày"}
                                    {KieuLaiSuat === 3 &&
                                      Phantram.toFixed(2) + "%"}
                                  </span>
                                </p>
                              </div>
                            </div>
                          )}
                        {Type === 3 && IsDuNoGiamDan === true && (
                          <div className="row">
                            <div className="col-6">
                              <p> Lãi suất:</p>
                            </div>
                            <div className="col-6 text-left text-normal">
                              <p className="home-new-yellow">
                                <span className="home-new-yellow">
                                  {StatusPaidHo === 1 &&
                                    formatNumber(
                                      Math.ceil(ValueLai * CountTypePaid),
                                    ) + "đ"}
                                  {StatusPaidHo === 2 &&
                                    formatNumber(
                                      Math.ceil(ValueLai * BocTrongVong),
                                    ) + "đ"}
                                  {StatusPaidHo === 3 &&
                                    ChiPhiVay.toFixed(2) + "%"}
                                </span>
                              </p>
                            </div>
                          </div>
                        )}
                        {Type === 2 && (
                          <div className="row">
                            <div className="col-6">
                              <p> Lãi suất:</p>
                            </div>
                            <div className="col-6 text-left text-normal">
                              <p>
                                <span className="home-new-yellow">
                                  {StatusPaidHo === 1 &&
                                    formatNumber(
                                      Math.ceil(ValueLai * CountTypePaid),
                                    ) + "đ"}

                                  {StatusPaidHo === 2 &&
                                    (laiTraGop === LAI_TRA_GOP_TRIEU_NGAY
                                      ? formatNumber(
                                          Math.round(
                                            laiDonViRaLaiTrieuNgay(
                                              ValueLai,
                                              Sotienvay,
                                              TypePaid !== 1 ||
                                                anDinhNgayThangTraGop,
                                            ),
                                          ),
                                        ) + "đ/triệu/ngày"
                                      : (Phantram ?? 0) > 0
                                        ? Phantram.toFixed(2) + "%"
                                        : formatNumber(
                                            Math.ceil(ValueLai * BocTrongVong),
                                          ) + "đ")}

                                  {StatusPaidHo === 3 &&
                                    ChiPhiVay.toFixed(2) + "%"}
                                </span>
                              </p>
                            </div>
                          </div>
                        )}
                        {Type !== 2 && IsDuNoGiamDan === false && (
                          <div className="row">
                            <div className="col-6">
                              <p> Số lần trả:</p>
                            </div>
                            <div className="col-6 text-left text-normal">
                              <p>
                                <span className="home-new-yellow">
                                  {SoLanTra} Lần
                                </span>
                              </p>
                            </div>
                          </div>
                        )}
                        {(Type === 3 && IsDuNoGiamDan === true) ||
                          (Type === 2 && (
                            <div className="row">
                              <div className="col-6">
                                <p> Bốc trong vòng: </p>
                              </div>
                              <div className="col-6 text-left text-normal">
                                <p className="home-new-yellow">
                                  {BocTrongVong}{" "}
                                  <span>
                                    {TypePaid === 1 ? "ngày" : "tháng"}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))}

                        {/* Tiếp tục cấu trúc tương tự cho các phần tử còn lại */}
                        <div className="row">
                          <div className="col-6">
                            <p>Ngày tất toán:</p>
                          </div>
                          <div className="col-6 text-left text-normal">
                            <p>{getDate(NgayTra)}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3 col-lg-3">
                      <div className="from-thongtinvay disable-border-textarea">
                        <p>
                          {" "}
                          <img src="/app-assets/images/icon-ghi-chu-v2.png" />{" "}
                          Ghi chú:
                        </p>
                        <textarea
                          className="col-md-12 col-lg-12"
                          value={Note}
                          readOnly
                          rows="7"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
              <Tab
                eventKey="chitietdonglai"
                title={
                  <h4 className="nav-link tab-v2">
                    <div className="badge badge-pill-v3 background-tim">
                      {" "}
                      {totalRow}&nbsp;
                    </div>
                    &nbsp;<span>Chi tiết đóng lãi</span>
                  </h4>
                }
              >
                <LanThanhToanTable
                  List={List}
                  TongCanThanhToan={TongCanThanhToan}
                  TongPhiKhac={TongPhiKhac}
                  TongPhiKho={TongPhiKho}
                  TongThanhToan={TongThanhToan}
                  TongTienGoc={TongTienGoc}
                  TongTienLai={TongTienLai}
                  totalRow={totalRow}
                  TongPhiKhacHangKy={TongPhiKhacHangKy}
                  handlePageChange={this.handlePageChange()}
                  pageIndex={dataSearch.pageIndex}
                  pageSize={dataSearch.pageSize}
                  showPhiKho={PhiKho}
                  Type={Type}
                  StatusPaidHo={StatusPaidHo}
                ></LanThanhToanTable>
              </Tab>
              {Type !== 2 && (
                <Tab
                  eventKey="lichsuvaythemtrabotgoc"
                  title={
                    <h4 className="nav-link tab-v2">
                      <div className="badge badge-pill-v3 background-tim">
                        {TotalRows}&nbsp;
                      </div>
                      &nbsp;<span>Lịch sử vay thêm trả bớt gốc</span>
                    </h4>
                  }
                >
                  <LichSuVayThemTraBotGocView
                    TongTien={TongTienVayThemTraBotGoc}
                    List={ListVTTB}
                    TotalRows={TotalRows}
                  ></LichSuVayThemTraBotGocView>
                </Tab>
              )}
              <Tab
                eventKey="taisancamco"
                title={
                  <h4 className="nav-link tab-v2">
                    <div className="badge badge-pill-v3 background-tim">
                      {TotalRowsCamCo}
                    </div>{" "}
                    &nbsp;
                    <span>{isCauHinhT77 ? "Tài sản" : "Tài sản  cầm cố"}</span>
                  </h4>
                }
                onEnter={runSlider}
              >
                {(Type === 3 || isCauHinhT77) && (
                  <ListTaiSanCamCoView
                    TongTien={CamDoTongPhiKho}
                    List={ListCamCo}
                    setModalTaiSan={setModalTaiSan}
                  ></ListTaiSanCamCoView>
                )}
                {Type !== 3 && !isCauHinhT77 && (
                  <div class="Left808x200" style={{ padding: "10px" }}>
                    <div id="ctl00_ContentPlaceHolder_ViewDetailChoVay_UpdatePanel12">
                      <div class="form-body form-bordered-1">
                        <div class="form-group row last-1">
                          <label class="col-md-3 label-control">
                            Tên tín chấp
                          </label>
                          <div class="col-md-9">{NoteTaiSan}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className="main-slider slider-ts"
                  style={{ background: "#FFFFFF" }}
                >
                  {Type !== 3 &&
                    !isCauHinhT77 &&
                    lstAnh.map((item) => (
                      <a href={item} data-fancybox="images">
                        <img src={item} alt="" />
                      </a>
                    ))}

                  {/* {Type !== 3 &&
                    lstAnh.map((item) => (
                      <a href={item} data-fancybox="images">
                        <img src={item} alt="" />
                      </a>
                    ))} */}
                </div>
              </Tab>
              {Type !== 2 && (
                <Tab
                  eventKey="lichsugiahan"
                  title={
                    <h4 className="nav-link tab-v2">
                      <div className="badge badge-pill-v3 background-tim">
                        {TotalRowGiaHan}&nbsp;
                      </div>
                      &nbsp;<span>Lịch sử gia hạn</span>
                    </h4>
                  }
                >
                  <LichSuGiaHanView
                    List={ListGiaHan}
                    pageIndex={dataGiaHanSearch.pageIndex}
                    pageSize={dataGiaHanSearch.pageSize}
                    TotalQuantity={TotalRowGiaHan}
                    handlePageChange={this.handlePageChangeGiaHan()}
                  ></LichSuGiaHanView>
                </Tab>
              )}

              <Tab
                eventKey="lichsunophaithu"
                title={
                  <h4 className="nav-link tab-v2">
                    <div className="badge badge-pill-v3 background-tim">
                      {TotalRowNoPhaiThu}&nbsp;
                    </div>
                    &nbsp;<span> Lịch sử nợ phải thu</span>
                  </h4>
                }
              >
                <LichSuNoPhaiThuView
                  List={ListLSNoPhaiThu}
                  pageIndex={dataNoPhaiThuSearch.pageIndex}
                  pageSize={dataNoPhaiThuSearch.pageSize}
                  TotalQuantity={TotalRowNoPhaiThu}
                  TongTien={TotalValue}
                  handlePageChange={this.handlePageChangeLSNoPhaiThu()}
                ></LichSuNoPhaiThuView>
              </Tab>
              <Tab
                eventKey="ghichu"
                title={
                  <h4 className="nav-link tab-v2">
                    <div className="badge badge-pill-v3 background-tim">
                      {TotalRowsGhiChu}&nbsp;
                    </div>
                    &nbsp;<span>Ghi chú</span>
                  </h4>
                }
              >
                <ListGhiChuView
                  List={ListGhiChu}
                  pageIndex={dataGhiChuSearch.pageIndex}
                  pageSize={dataGhiChuSearch.pageSize}
                  TotalQuantity={TotalRowsGhiChu}
                  handlePageChange={this.handlePageChangeGhiChu()}
                ></ListGhiChuView>
              </Tab>
              <Tab
                eventKey="lichsu"
                title={
                  <h4 className="nav-link tab-v2">
                    <div className="badge badge-pill-v3 background-tim">
                      {TotalRowLichSu}&nbsp;
                    </div>
                    &nbsp;<span> Lịch sử</span>
                  </h4>
                }
              >
                <LichSuHopDongView
                  List={ListLichSu}
                  pageIndex={dataLichSuSearch.pageIndex}
                  pageSize={dataLichSuSearch.pageSize}
                  TotalQuantity={TotalRowLichSu}
                  TongTien={TotalSoTienLS}
                  handlePageChange={this.handlePageChangeLichSu()}
                ></LichSuHopDongView>
              </Tab>
              <Tab
                eventKey="fileDinhKem"
                title={
                  <h4 className="nav-link tab-v2">
                    <img src="/app-assets/images/icon-file-dinh-kem-v2.png" />
                    &nbsp;File đính kèm
                  </h4>
                }
              >
                <div>
                  {listFile.map((item, index) => (
                    <div className="col-sm-5">
                      <a href={item.view} target="_blank" download>
                        {item.Name}
                      </a>
                    </div>
                  ))}
                </div>
              </Tab>
            </Tabs>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-right">
            <button
              type="button"
              className="btn btn-new-main btn-closenew"
              onClick={onHide}
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-close"></i>
              </span>
              Đóng
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ChiTietHopDong;
